import React from 'react';

const DownloadResume = () => {
  return (
    <div id="fh5co-started" className="fh5co-bg-dark">
      <div className="overlay"></div>
      <div className="container">
        <div className="row animate-box">
          <div className="col-md-8 col-md-offset-2 text-center fh5co-heading">
            <h2>Download Resume</h2>
            <p>Please find the printable resume</p>
            <p><a href="resume-html/index.html" target="_blank" rel="noopener noreferrer" className="btn btn-default btn-lg">Download</a></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadResume;
